"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _TimePicker = _interopRequireDefault(require("../TimePicker"));

var _Input = _interopRequireDefault(require("../Input"));

var _DropDown = _interopRequireWildcard(require("../DropDown"));

var _time = _interopRequireDefault(require("../icons/time.svg"));

var _cross = _interopRequireDefault(require("../icons/cross.svg"));

var _dateParser = require("../_utils/dateParser");

var _keyCodes = require("../_utils/keyCodes");

var InputTimePicker =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(InputTimePicker, _PureComponent);

  function InputTimePicker() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, InputTimePicker);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(InputTimePicker)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "controlled", _this.props.hasOwnProperty('value'));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "state", {
      value: !_this.controlled ? _this.parse(_this.props.defaultValue) : _this.props.value
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "handleClear", function (e) {
      e.stopPropagation();
      e.preventDefault();

      _this.setState({
        value: ''
      });

      _this.props.onChange && _this.props.onChange(null);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "handleFocus", function (e) {
      if (_this.isActive()) {
        _this.dropDownRef.show();

        _this.props.onFocus && _this.props.onFocus(e);

        _this.setState({
          input: e.target.value
        });
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "handleBlur", function (e) {
      var value = _this.parse(e.target.value, true);
      /**
       * Hack to close dropdown if we have already opened dropdow for input field
       */


      setImmediate(function () {
        if (document.activeElement.tagName == 'INPUT') {
          _this.dropDownRef.hide();
        }
      });

      if (!_this.controlled) {
        _this.setState({
          value: value
        });
      }

      if (_this.state.changed) {
        _this.props.onChange && _this.props.onChange((0, _dateParser.parseTime)(value));
      }

      _this.props.onBlur && _this.props.onBlur(e);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "handleInputChange", function (e) {
      _this.setState({
        input: e.target.value,
        value: _this.parse(e.target.value),
        changed: true
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "handleTimePickerChange", function (value) {
      var parsed = _this.parse(value);

      _this.setState({
        input: parsed,
        value: parsed,
        changed: false
      });

      _this.props.onChange && _this.props.onChange(value);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "handleKeyUp", function (e) {
      if (e.keyCode === _keyCodes.KEY_CODE_SUBMIT) {
        e.preventDefault();

        _this.dropDownRef.hide();
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "handleDropDownHide", function () {
      _this.setState({
        focus: false
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "handleDropDownShow", function () {
      _this.setState({
        focus: true
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "handleDropDownRef", function (elem) {
      return _this.dropDownRef = elem;
    });
    return _this;
  }

  (0, _createClass2.default)(InputTimePicker, [{
    key: "parse",
    value: function parse(value) {
      return (0, _dateParser.parseTime)(value).format('LT');
    }
  }, {
    key: "isActive",
    value: function isActive() {
      var _this$props = this.props,
          readOnly = _this$props.readOnly,
          disabled = _this$props.disabled;
      return !readOnly && !disabled;
    }
  }, {
    key: "render",
    value: function render() {
      var props = (0, _extends2.default)({}, this.props);
      var _this$state = this.state,
          focus = _this$state.focus,
          value = _this$state.value,
          step = _this$state.step;
      delete props.defaultValue;
      props.value = value || '';

      if (focus) {
        props.value = value === '' ? value : this.state.input;
      }

      var input = _react.default.createElement(_Input.default, (0, _extends2.default)({}, props, {
        hasFocus: focus,
        Icon: props.value ? _cross.default : _time.default,
        onIconClick: props.value ? this.handleClear : null,
        onFocus: this.handleFocus,
        onBlur: this.handleBlur,
        onChange: this.handleInputChange,
        autoComplete: "off"
      }));

      if (!this.isActive()) {
        return input;
      }

      return _react.default.createElement(_DropDown.default, {
        className: (0, _classnames.default)('form-field'),
        trigger: input,
        ref: this.handleDropDownRef,
        align: _DropDown.ALIGN_LEFT | _DropDown.ALIGN_BOTTOM,
        onShow: this.handleDropDownShow,
        step: step,
        onHide: this.handleDropDownHide
      }, _react.default.createElement(_TimePicker.default, {
        value: value || '',
        onChange: this.handleTimePickerChange,
        onKeyUp: this.handleKeyUp
      }));
    }
  }]);
  return InputTimePicker;
}(_react.PureComponent);

exports.default = InputTimePicker;
InputTimePicker.propTypes = process.env.NODE_ENV !== "production" ? {
  range: _propTypes.default.bool,
  error: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.string), _propTypes.default.string]),
  label: _propTypes.default.string,
  defaultValue: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.object]),
  value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.object]),
  disabled: _propTypes.default.bool,
  onFocus: _propTypes.default.func,
  onBlur: _propTypes.default.func,
  onChange: _propTypes.default.func,
  step: _propTypes.default.number
} : {};